import { type RootContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { localStateSelector, makeLocalStateIsLinkSentSelector } from "../selectors";
import Component, { type ActionProps, type MapProps } from "./component";
import { makeFieldsSelector } from "./selectors";

const makeMapStateToProps = () => {
  const fieldsSelector = makeFieldsSelector();
  const isLinkSentSelector = makeLocalStateIsLinkSentSelector();

  return (state: AppState, props: RootContainerProps): MapProps => {
    const localState = localStateSelector(state, props);

    return {
      ...props,
      error: localState.error,

      isLinkSent: isLinkSentSelector(state, props),
      fields: fieldsSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: RootContainerProps): ActionProps => ({});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
